import type { CapacityObligation } from '@/features/bidding/types/capacityObligations'

/**
 * Per-activation-group daily obligation total (watts), keyed by AG UUID.
 * Sums every PTU's obligation volume per AG. Drives the OBL figure shown
 * against each AG in the multi-select dropdown.
 */
export function computePerActivationGroupObligationTotals(
  obligations: ReadonlyArray<CapacityObligation>,
): Map<string, number> {
  const totalByActivationGroup = new Map<string, number>()
  for (const obligation of obligations) {
    const watts = obligation.ptus.reduce((sum, ptu) => sum + ptu.volume.quantity, 0)
    totalByActivationGroup.set(
      obligation.activationGroupUuid,
      (totalByActivationGroup.get(obligation.activationGroupUuid) ?? 0) + watts,
    )
  }

  return totalByActivationGroup
}
